export default {"src":"/_next/static/media/chevron-down.0081c90f.svg","height":8,"width":14,"blurWidth":0,"blurHeight":0};